import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { C } from '../landing.theme'
import { Ic } from '../ui/Ic'
import { Logo } from '../ui/Logo'

const NAV_LINKS = [
  ['#features', 'Возможности'],
  ['#how',      'Как работает'],
  ['#gallery',  'Проекты'],
  ['#about',    'О нас'],
  ['#faq',      'Вопросы'],
]

const USER_MENU_ITEMS = [
  { label:'Личный кабинет', sub:'Мой профиль',        ic:'user',   path:'/dashboard' },
  { label:'Мои проекты',    sub:'Список сохранённых',  ic:'folder', path:'/dashboard?tab=projects' },
  { label:'Создать проект', sub:'Открыть конструктор', ic:'plus',   path:'/app', appOnly:true },
]

const IC_COLORS = [
  { bg:'linear-gradient(135deg,rgba(31,200,214,.18),rgba(10,123,134,.10))', border:'rgba(31,200,214,.28)', color:'#1FC8D6' },
  { bg:'linear-gradient(135deg,rgba(99,102,241,.18),rgba(67,56,202,.10))',  border:'rgba(99,102,241,.28)', color:'#818cf8' },
  { bg:'linear-gradient(135deg,rgba(34,197,94,.18),rgba(22,163,74,.10))',   border:'rgba(34,197,94,.28)',  color:'#4ade80' },
]

export default function Nav({ onLogin, isAuth }) {
  const [solid,  setSolid]  = useState(false)
  const [mob,    setMob]    = useState(false)
  const [uMenu,  setUMenu]  = useState(false)
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const fn = () => setSolid(window.scrollY > 50)
    window.addEventListener('scroll', fn, { passive: true })
    return () => window.removeEventListener('scroll', fn)
  }, [])

  useEffect(() => {
    document.body.style.overflow = mob ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [mob])

  const initials = (user?.name || '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || '?'
  const go = path => { setUMenu(false); setMob(false); navigate(path) }

  const handleLogout = async () => {
    setUMenu(false)
    setMob(false)
    try { await logout() } catch (_) { navigate('/') }
  }

  return (
    <>
      <header style={{
        position:'fixed', top:0, left:0, right:0, zIndex:100,
        borderBottom:`1px solid ${solid ? '#122840' : 'transparent'}`,
        background: solid ? 'rgba(4,13,24,.93)' : 'transparent',
        backdropFilter: solid ? 'blur(22px)' : 'none',
        transition:'all .3s',
      }}>
        <div className="wrap" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', height:72 }}>
          <a href="/" aria-label="Welland Create — главная" style={{ textDecoration:'none' }} onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }) }}>
            <Logo s={30} />
          </a>

          <nav className="nav-links" style={{ display:'flex', gap:26 }}>
            {NAV_LINKS.map(([h, l]) => (
              <a key={h} href={h} style={{ fontSize:14, fontWeight:600, color:C.s2, transition:'color .2s' }}
                onMouseEnter={e => e.target.style.color = '#fff'}
                onMouseLeave={e => e.target.style.color = C.s2}>
                {l}
              </a>
            ))}
          </nav>

          <div style={{ display:'flex', gap:8, alignItems:'center' }}>
            {isAuth ? (
              <div style={{ position:'relative', width:252 }} className="nav-user-wrap">
                {/* Trigger button */}
                <button className="nav-user-btn" onClick={() => setUMenu(v => !v)} style={{
                  display:'flex', alignItems:'center', justifyContent:'space-between', gap:8,
                  width:'100%', padding:'4px 12px 4px 4px', borderRadius:999,
                  border:`1px solid ${uMenu ? 'rgba(31,200,214,.55)' : 'rgba(255,255,255,.11)'}`,
                  background: uMenu ? 'rgba(15,163,177,.1)' : 'rgba(255,255,255,.05)',
                  cursor:'pointer', transition:'all .22s',
                  boxShadow: uMenu ? '0 0 0 3px rgba(15,163,177,.14)' : 'none',
                }}
                onMouseEnter={e => { if (!uMenu) { e.currentTarget.style.borderColor='rgba(31,200,214,.4)'; e.currentTarget.style.background='rgba(15,163,177,.07)' }}}
                onMouseLeave={e => { if (!uMenu) { e.currentTarget.style.borderColor='rgba(255,255,255,.11)'; e.currentTarget.style.background='rgba(255,255,255,.05)' }}}>
                  <div style={{ width:34, height:34, borderRadius:'50%', background:'linear-gradient(135deg,#1FC8D6,#0A7B86)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12.5, fontWeight:800, color:'#fff', flexShrink:0, boxShadow:'0 2px 8px rgba(15,163,177,.35)' }}>{initials}</div>
                  <span className="nav-user-name" style={{ flex:1, fontSize:14, fontWeight:700, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', textAlign:'left' }}>{user?.name || 'Профиль'}</span>
                  <svg className="nav-user-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                    style={{ color:'rgba(255,255,255,.45)', transition:'transform .22s', transform: uMenu ? 'rotate(180deg)' : 'none', flexShrink:0 }}>
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </button>

                {/* Dropdown panel */}
                {uMenu && (
                  <>
                    <div onClick={() => setUMenu(false)} style={{ position:'fixed', inset:0, zIndex:98 }}/>
                    <div style={{
                      position:'absolute', top:'calc(100% + 8px)', right:0,
                      width:252, maxWidth:'calc(100vw - 20px)',
                      background:'rgba(5,12,24,.82)',
                      backdropFilter:'blur(36px) saturate(160%)',
                      WebkitBackdropFilter:'blur(36px) saturate(160%)',
                      border:'1px solid rgba(255,255,255,.13)',
                      borderRadius:18, overflow:'hidden',
                      boxShadow:'0 12px 40px rgba(0,0,0,.55), inset 0 1px 0 rgba(255,255,255,.12), inset 0 -1px 0 rgba(0,0,0,.2)',
                      zIndex:99,
                      animation:'wlMenuIn .22s cubic-bezier(.16,1,.3,1)',
                    }}>
                      <div style={{ height:1.5, background:'linear-gradient(90deg,transparent,rgba(31,200,214,.7) 35%,rgba(15,163,177,.7) 65%,transparent)' }}/>

                      {/* User header */}
                      <div style={{ padding:'11px 12px 9px', display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ position:'relative', flexShrink:0 }}>
                          <div style={{ width:38, height:38, borderRadius:'50%', background:'linear-gradient(135deg,#1FC8D6,#0A7B86)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:900, color:'#fff', boxShadow:'0 2px 10px rgba(15,163,177,.45)' }}>{initials}</div>
                          <div style={{ position:'absolute', bottom:1, right:0, width:8, height:8, borderRadius:'50%', background:'#22c55e', border:'1.5px solid rgba(5,12,24,.9)', boxShadow:'0 0 5px rgba(34,197,94,.7)' }}/>
                        </div>
                        <div style={{ minWidth:0, flex:1 }}>
                          <div style={{ fontSize:13, fontWeight:800, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', letterSpacing:'-.015em' }}>{user?.name || 'Пользователь'}</div>
                          <div style={{ fontSize:10.5, color:'rgba(180,210,230,.72)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', marginTop:1.5, fontFamily:"'JetBrains Mono',monospace" }}>{user?.email || ''}</div>
                        </div>
                      </div>

                      <div style={{ height:'1px', background:'linear-gradient(90deg,transparent,rgba(255,255,255,.12) 30%,rgba(255,255,255,.12) 70%,transparent)', margin:'0 10px 4px' }}/>

                      {/* Menu items */}
                      <div style={{ padding:'0 6px 6px' }}>
                        {USER_MENU_ITEMS.map((item, i) => {
                          const ic = IC_COLORS[i] || IC_COLORS[0]
                          return (
                            <button key={item.label} onClick={() => go(item.path)}
                              className="wl-drop-item"
                              style={{ padding:'6px 8px', marginBottom: i < USER_MENU_ITEMS.length - 1 ? 1 : 0 }}
                              onMouseEnter={e => {
                                e.currentTarget.style.background = 'rgba(255,255,255,.09)'
                                const wrap = e.currentTarget.querySelector('.drop-ic')
                                if (wrap) { wrap.style.borderColor = ic.border.replace('.28)','.5)'); wrap.style.background = ic.bg.replace('.18)','.26)').replace('.10)','.16)') }
                              }}
                              onMouseLeave={e => {
                                e.currentTarget.style.background = 'transparent'
                                const wrap = e.currentTarget.querySelector('.drop-ic')
                                if (wrap) { wrap.style.borderColor = ic.border; wrap.style.background = ic.bg }
                              }}>
                              <div className="drop-ic" style={{ width:30, height:30, borderRadius:9, flexShrink:0, background:ic.bg, border:`1px solid ${ic.border}`, display:'flex', alignItems:'center', justifyContent:'center', color:ic.color, transition:'all .16s' }}>
                                <Ic n={item.ic} s={14}/>
                              </div>
                              <div style={{ flex:1, minWidth:0 }}>
                                <div style={{ fontSize:13, fontWeight:700, color:'#fff', lineHeight:1.2 }}>{item.label}</div>
                                <div style={{ fontSize:10.5, color:'rgba(180,210,230,.65)', lineHeight:1.3, marginTop:1 }}>{item.sub}</div>
                              </div>
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.28)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                            </button>
                          )
                        })}
                      </div>

                      <div style={{ height:'1px', background:'rgba(255,255,255,.08)', margin:'0 10px' }}/>
                      <div style={{ padding:'5px 6px 7px' }}>
                        <button onClick={handleLogout}
                          className="wl-drop-item"
                          style={{ padding:'6px 8px' }}
                          onMouseEnter={e => { e.currentTarget.style.background='rgba(248,113,113,.1)' }}
                          onMouseLeave={e => { e.currentTarget.style.background='transparent' }}>
                          <div style={{ width:30, height:30, borderRadius:9, flexShrink:0, background:'rgba(248,113,113,.1)', border:'1px solid rgba(248,113,113,.22)', display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(248,113,113,.9)', transition:'all .16s' }}>
                            <Ic n="logout" s={14}/>
                          </div>
                          <div style={{ flex:1 }}>
                            <div style={{ fontSize:13, fontWeight:700, color:'rgba(248,113,113,.95)', lineHeight:1.2 }}>Выйти</div>
                            <div style={{ fontSize:10.5, color:'rgba(248,113,113,.6)', lineHeight:1.3, marginTop:1 }}>Сменить аккаунт</div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <>
                <button onClick={onLogin} style={{ background:'rgba(255,255,255,.08)', border:`1px solid ${C.line}`, borderRadius:999, padding:'9px 18px', color:C.s1, fontSize:14, fontWeight:600, cursor:'pointer', transition:'all .2s' }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor=C.teal; e.currentTarget.style.color='#fff' }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor=C.line; e.currentTarget.style.color=C.s1 }}>
                  Войти
                </button>
                <button className="btn btn-p nav-cta-d" style={{ padding:'10px 20px', fontSize:14 }} onClick={onLogin}>
                  <Ic n="cube" s={15}/>Создать проект
                </button>
              </>
            )}
            <button className="burger" aria-label="Открыть меню" onClick={() => setMob(true)} style={{ width:42, height:42, background:'rgba(255,255,255,.07)', border:`1px solid rgba(255,255,255,.1)`, borderRadius:12, display:'none', alignItems:'center', justifyContent:'center', color:'rgba(255,255,255,.8)', cursor:'pointer', flexShrink:0 }}>
              <Ic n="menu" s={20}/>
            </button>
          </div>
        </div>
      </header>

      {/* ── Mobile overlay ── */}
      {mob && (
        <div style={{ position:'fixed', inset:0, zIndex:200, display:'flex', flexDirection:'column',
          background:'linear-gradient(170deg,rgba(3,10,22,1) 0%,rgba(2,7,17,1) 100%)',
          backdropFilter:'blur(32px)' }}>

          {/* Ambient glow */}
          <div style={{ position:'absolute', top:-80, left:'50%', transform:'translateX(-50%)', width:320, height:200,
            background:'radial-gradient(ellipse,rgba(15,163,177,.18) 0%,transparent 70%)', pointerEvents:'none' }}/>

          {/* Top bar */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'18px 20px', flexShrink:0 }}>
            <Logo s={28}/>
            <button onClick={() => setMob(false)} style={{ width:40, height:40, background:'rgba(255,255,255,.07)', border:'1px solid rgba(255,255,255,.09)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(255,255,255,.6)', cursor:'pointer', transition:'all .18s' }}
              onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,.12)'}
              onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,.07)'}>
              <Ic n="x" s={17}/>
            </button>
          </div>

          <div style={{ flex:1, overflowY:'auto', padding:'8px 18px 36px', display:'flex', flexDirection:'column', gap:6, position:'relative' }}>
            {isAuth ? (
              <>
                {/* User card */}
                <div style={{ background:'linear-gradient(135deg,rgba(15,163,177,.12),rgba(31,200,214,.06))', border:'1px solid rgba(31,200,214,.2)', borderRadius:18, padding:'16px', marginBottom:10, position:'relative', overflow:'hidden' }}>
                  <div style={{ position:'absolute', top:-30, right:-30, width:100, height:100, borderRadius:'50%', background:'radial-gradient(circle,rgba(31,200,214,.12),transparent 70%)', pointerEvents:'none' }}/>
                  <div style={{ display:'flex', alignItems:'center', gap:13 }}>
                    <div style={{ position:'relative', flexShrink:0 }}>
                      <div style={{ width:50, height:50, borderRadius:'50%', background:'linear-gradient(135deg,#1FC8D6,#0A7B86)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, fontWeight:900, color:'#fff', boxShadow:'0 4px 16px rgba(15,163,177,.5)' }}>{initials}</div>
                      <div style={{ position:'absolute', bottom:1, right:1, width:11, height:11, borderRadius:'50%', background:'#22c55e', border:'2px solid rgba(2,8,18,1)', boxShadow:'0 0 7px rgba(34,197,94,.8)' }}/>
                    </div>
                    <div style={{ minWidth:0, flex:1 }}>
                      <div style={{ fontSize:15.5, fontWeight:800, color:'#fff', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', letterSpacing:'-.02em' }}>{user?.name || 'Пользователь'}</div>
                      <div style={{ fontSize:11.5, color:'rgba(31,200,214,.7)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', marginTop:3, fontFamily:"'JetBrains Mono',monospace" }}>{user?.email || ''}</div>
                    </div>
                  </div>
                </div>

                {/* Divider label */}
                <div style={{ fontSize:10, fontWeight:700, color:'rgba(255,255,255,.25)', letterSpacing:'.12em', textTransform:'uppercase', padding:'4px 4px 2px' }}>Аккаунт</div>

                {/* Account items — на мобиле скрываем переходы в приложение */}
                {USER_MENU_ITEMS.filter(item => !item.appOnly).map((item, i) => {
                  const ic = IC_COLORS[i] || IC_COLORS[0]
                  return (
                    <button key={item.label} onClick={() => go(item.path)} style={{ display:'flex', alignItems:'center', gap:14, background:'rgba(255,255,255,.04)', border:'1px solid rgba(255,255,255,.07)', borderRadius:14, padding:'13px 15px', width:'100%', cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", transition:'all .18s', textAlign:'left' }}
                      onMouseEnter={e=>{ e.currentTarget.style.background='rgba(255,255,255,.08)'; e.currentTarget.style.borderColor='rgba(255,255,255,.13)' }}
                      onMouseLeave={e=>{ e.currentTarget.style.background='rgba(255,255,255,.04)'; e.currentTarget.style.borderColor='rgba(255,255,255,.07)' }}>
                      <div style={{ width:40, height:40, borderRadius:12, flexShrink:0, background:ic.bg, border:`1px solid ${ic.border}`, display:'flex', alignItems:'center', justifyContent:'center', color:ic.color }}>
                        <Ic n={item.ic} s={18}/>
                      </div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:14.5, fontWeight:700, color:'#fff', lineHeight:1.25, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{item.label}</div>
                        <div style={{ fontSize:11.5, color:'rgba(180,210,230,.5)', marginTop:2 }}>{item.sub}</div>
                      </div>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.2)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0 }}><polyline points="9 18 15 12 9 6"/></svg>
                    </button>
                  )
                })}

                {/* Logout */}
                <div style={{ marginTop:6, borderTop:'1px solid rgba(255,255,255,.06)', paddingTop:10 }}>
                  <button onClick={handleLogout} style={{ display:'flex', alignItems:'center', gap:14, background:'rgba(248,113,113,.06)', border:'1px solid rgba(248,113,113,.15)', borderRadius:14, padding:'13px 15px', width:'100%', cursor:'pointer', fontFamily:"'Plus Jakarta Sans',sans-serif", transition:'all .18s', textAlign:'left' }}
                    onMouseEnter={e=>{ e.currentTarget.style.background='rgba(248,113,113,.11)'; e.currentTarget.style.borderColor='rgba(248,113,113,.25)' }}
                    onMouseLeave={e=>{ e.currentTarget.style.background='rgba(248,113,113,.06)'; e.currentTarget.style.borderColor='rgba(248,113,113,.15)' }}>
                    <div style={{ width:40, height:40, borderRadius:12, flexShrink:0, background:'rgba(248,113,113,.1)', border:'1px solid rgba(248,113,113,.2)', display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(248,113,113,.9)' }}>
                      <Ic n="logout" s={18}/>
                    </div>
                    <div style={{ textAlign:'left' }}>
                      <div style={{ fontSize:14.5, fontWeight:700, color:'rgba(248,113,113,.95)' }}>Выйти</div>
                      <div style={{ fontSize:11.5, color:'rgba(248,113,113,.45)', marginTop:2 }}>Сменить аккаунт</div>
                    </div>
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* Nav links for guests */}
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:2, padding:'16px 0 24px' }}>
                  {NAV_LINKS.map(([h, l]) => (
                    <a key={h} href={h} onClick={() => setMob(false)} style={{ color:'rgba(255,255,255,.82)', fontSize:24, fontWeight:800, padding:'10px 0', letterSpacing:'-.025em', textDecoration:'none', width:'100%', textAlign:'center', transition:'color .18s' }}
                      onMouseEnter={e=>e.target.style.color='#1FC8D6'}
                      onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.82)'}>{l}</a>
                  ))}
                </div>
                <div style={{ height:1, background:'rgba(255,255,255,.07)', margin:'0 0 10px' }}/>
                <button className="btn btn-p" style={{ padding:'16px 32px', fontSize:16, width:'100%' }} onClick={() => { setMob(false); onLogin() }}>
                  <Ic n="cube" s={18}/>Войти / Создать проект
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}
